<mat-toolbar class="p-0 mat-elevation-z1">
  <div class="tlbr-main">
    <div class="tlbr-left">
      <button
        mat-icon-button
        class="navbar-toggle-button"
        *ngIf="!hiddenNavbar && !rightNavbar"
        (click)="toggleSidebarOpen('navbar')"
        fxHide.gt-md
      >
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
      <div
        class="toolbar-separator"
        *ngIf="!hiddenNavbar && !rightNavbar"
        fxHide.gt-md
      ></div>
      <div *ngIf="horizontalNavbar">
        <div class="logo ml-16">
          <img class="logo-icon" src="assets/images/logos/fuse.svg" />
        </div>
      </div>
      <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
    </div>
    <div class="tlbr-rigth">
      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>
      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          *ngIf="account$ as account"
        >
          <img class="avatar mr-0 mr-sm-16" [src]="sanitizeImagen(account)" />
          <span class="username mr-12" fxHide fxShow.gt-sm
            >{{ account$.nombre }} {{ account$.apellido }}</span
          >
          <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
        </div>
      </button>
      <mat-menu #subMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item [routerLink]="['/token']">
          <mat-icon>vpn_key</mat-icon>
          <span>Token</span>
        </button>
        <button mat-menu-item [routerLink]="['/perfil/imagen']">
          <mat-icon>account_circle</mat-icon>
          <span>Imagen</span>
        </button>
        <button mat-menu-item [routerLink]="['/perfil/informacion']">
          <mat-icon>contacts</mat-icon>
          <span>Información</span>
        </button>
      </mat-menu>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item [routerLink]="['/profile']">
          <mat-icon>account_circle</mat-icon>
          <span>Mi Perfil</span>
        </button>

        <button mat-menu-item [matMenuTriggerFor]="subMenu">
          <mat-icon>account_circle</mat-icon>
          <span>Perfil</span>
        </button>

        <button (click)="logout()" mat-menu-item>
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>

      <div class="toolbar-separator"></div>

      <fuse-search-bar (input)="search($event)"></fuse-search-bar>

      <div class="toolbar-separator"></div>

      <button
        mat-button
        fxHide
        fxShow.gt-xs
        class="language-button"
        [matMenuTriggerFor]="languageMenu"
      >
        <div fxLayout="row" fxLayoutAlign="center center">
          <img
            class="flag mr-8"
            [src]="'assets/icons/flags/' + selectedLanguage.flag + '.png'"
          />
          <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
        </div>
      </button>

      <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        <button
          mat-menu-item
          *ngFor="let lang of languages"
          (click)="setLanguage(lang)"
        >
          <span fxLayout="row" fxLayoutAlign="start center">
            <img
              class="flag mr-16"
              [src]="'assets/icons/flags/' + lang.flag + '.png'"
            />
            <span class="iso">{{ lang.title }}</span>
          </span>
        </button>
      </mat-menu>

      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

      <button
        mat-icon-button
        class="quick-panel-toggle-button"
        (click)="toggleSidebarOpen('quickPanel')"
        aria-label="Toggle quick panel"
      >
        <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
      </button>

      <div
        class="toolbar-separator"
        *ngIf="!hiddenNavbar && rightNavbar"
        fxHide
        fxShow.gt-xs
      ></div>

      <button
        mat-icon-button
        class="navbar-toggle-button"
        *ngIf="!hiddenNavbar && rightNavbar"
        (click)="toggleSidebarOpen('navbar')"
        fxHide.gt-md
      >
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
